import React, {useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import DropdownSelect from '#components/m/DropdownSelect'
import Api from '#services/api'
import actions from 'redux-auto'

function createDropdownOption(ausbildungsjahr) {
  return {value: ausbildungsjahr, label: i18n.t('meineazubis_ausbildungsjahr', [ausbildungsjahr])}
}

function AusbildungsjahrCell({reloadAzubis, azubi, canChangeAusbildungsjahr}) {
  if (!canChangeAusbildungsjahr) {
    const ausbildungsJahrFormatted = i18n.t('meineazubis_ausbildungsjahr', [azubi.ausbildungsjahr])
    return (
      <div>
        <span>{ausbildungsJahrFormatted}</span>
      </div>
    )
  }
  if (azubi.ausbildungsjahr <= 0) {
    const ausbildungNotStarted = i18n.t('meineazubis_ausbildung_not_started')
    return (
      <div>
        <span>{ausbildungNotStarted}</span>
      </div>
    )
  }

  const ausbildungsjahrOptions = []
  ausbildungsjahrOptions[0] = createDropdownOption(1)
  ausbildungsjahrOptions[1] = createDropdownOption(2)
  ausbildungsjahrOptions[2] = createDropdownOption(3)
  ausbildungsjahrOptions[3] = createDropdownOption(4)
  ausbildungsjahrOptions[4] = createDropdownOption(5)
  const [selectedAusbildungsjahr, setSelectedAusbildungsjahr] = useState(
    ausbildungsjahrOptions.find(o => o.value === azubi.ausbildungsjahr),
  )

  const onSelectionChanged = async value => {
    const selectedOption = ausbildungsjahrOptions.find(o => o.value === value)
    setSelectedAusbildungsjahr(selectedOption)
    try {
      await Api.updateAusbildungsjahr(azubi.id, value)
      reloadAzubis()
    } catch (e) {
      actions.error.writeError({error: e})
    }
  }

  return (
    <DropdownSelect
      options={ausbildungsjahrOptions}
      selectedOption={selectedAusbildungsjahr}
      handleSelect={option => onSelectionChanged(option.value)}
      dataTestId="ausbildungsjahrCell"
    />
  )
}

AusbildungsjahrCell.propTypes = {
  azubi: PropTypes.shape({
    ausbildungsjahr: PropTypes.number,
    id: PropTypes.any,
  }),
  reloadAzubis: PropTypes.func.isRequired,
}

export default AusbildungsjahrCell
